import { ProductProps } from "../../types/ComponentProps";
import ProductCardStyles from "./ProductCardStyles.module.css";

type ProductTypeProps = {
  product: ProductProps;
  showModalClickHandler: (productId: number, productType: string) => void;
};

const formatCoins = (n: number) => n.toLocaleString("en-PH");

const getCoinLabel = (product: ProductProps): string | null => {
  if (product.type === "Custom Voucher") {
    return "From ₱500";
  }

  if (product.price === null || product.price === undefined) return null;
  if (product.price <= 0) return null;

  const addOns = Array.isArray(product.addOns) ? product.addOns : [];
  const addOnPrices = addOns
    .map((a: any) => Number(a.price))
    .filter((p: number) => !isNaN(p) && p > 0);

  if (addOnPrices.length > 0) {
    const min = Math.min(product.price, ...addOnPrices);
    return `From ₱${formatCoins(min)}`;
  }

  return `₱${formatCoins(product.price)}`;
};

const ProductCard = ({ product, showModalClickHandler }: ProductTypeProps) => {
  const coinLabel = getCoinLabel(product);

  return (
    <div
      className={ProductCardStyles.productCardContainer}
      onClick={() =>
        showModalClickHandler(Number(product?.productId), String(product.type))
      }
    >
      <div className={ProductCardStyles.imageWrapper}>
        <img src={product?.imageURL} alt={product?.productName} />
        {coinLabel && (
          <span className={ProductCardStyles.priceBadge}>{coinLabel}</span>
        )}
      </div>
      <div className={ProductCardStyles.flexBoxBlk}>
        <h2>{product.productName}</h2>
      </div>
    </div>
  );
};

export default ProductCard;
